module.exports = __webpack_public_path__ + "img/ico_logout--re.9e3f103f.svg";